<template>
  <div class="outsider_body">
    <!-- <header></header> -->
    <div class="header">
      <div class="head_warp">
        <div class="head_title">
          {{ $store.state.eduWebConfig.eduWebConfigInfo.webName }}
        </div>
      </div>
    </div>
    <!-- conotent -->
    <div class="content">
      <div class="warp" style="height: calc(100vh - 190px)">
        <div class="current_title">
          <div class="title">
            {{
              $store.state.eduWebConfig.eduWebConfigInfo.scaleAlias
                ? "问卷列表"
                : "量表列表"
            }}
          </div>
          <div class="close cursor">
            <span @click="close">返回</span>
          </div>
        </div>
        <el-table
          class="task_tab"
          :data="outsiderScaleList"
          style="width: 100%"
          header-cell-class-name="table-header-cell"
          :height="tabHeight"
        >
          <el-table-column type="index" label="#"></el-table-column>
          <el-table-column
            prop="title"
            :label="
              $store.state.eduWebConfig.eduWebConfigInfo.scaleAlias
                ? '问卷名称'
                : '量表名称'
            "
            width="300"
          ></el-table-column>
          <el-table-column
            prop="description"
            label="描述信息"
          ></el-table-column>
          <el-table-column prop="instruction" label="指导语"></el-table-column>
          <el-table-column
            label="状态"
            align="center"
            header-align="center"
            width="150"
          >
            <template v-slot="scope">
              <img
                :src="
                  scope.row.completed
                    ? '/static/images/finish.png'
                    : '/static/images/unfinish.png'
                "
                width="45"
                height="45"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template v-slot="scope">
              <el-button
                type="text"
                v-show="false"
                v-if="scope.row.completed"
                @click="toFinish(scope.row)"
                >查看</el-button
              >
              <el-button type="text" v-else @click="Finish(scope.row)"
                >去完成</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--  -->
    <!-- 指导语弹框 -->
    <el-dialog
      class="instruction"
      title="指导语"
      :visible.sync="centerDialogVisible"
      center
    >
      <span>{{ instruction }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toFinish">确 定</el-button>
      </span>
    </el-dialog>
    <!--  -->
    <!--footer-->
    <div class="main-footer">
      <p>
        <a target="_bank" href="https://beian.miit.gov.cn"
          >蜀ICP备20012822号-4</a
        >
      </p>
      <p>
        <a href="http://www.bluerhyme.net/" target="_bank"
          ><img class="bottom_logo" src="/static/images/logo_icon.png" />{{
            $store.state.eduWebConfig.eduWebConfigInfo.scaleAlias
              ? "四川蓝韵心理咨询服务有限公司"
              : "四川蓝韵心理咨询服务有限公司"
          }}</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      outsiderScaleList: [],
      tabHeight: window.innerHeight - 240,
      provinceList: [],
      cityList: [],
      countyList: [],
      schoolList: [],
      gradeList: [],
      classList: [],
      isNext: true,
      instruction: null,
      centerDialogVisible: false,
      form: {
        outsiderId: null,
      },
      outsiderInfo: {},
      ruleForm: {
        pass: "",
        checkPass: "",
      },
      formRules: {
        outsiderId: [
          { required: true, message: "请输入登记号", trigger: "blur" },
        ],
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getscaleList();
  },
  methods: {
    // 关闭当前页面
    close() {
      this.$router.push({
        name: "answerRegister",
      });
    },
    //   获取量表列表
    getscaleList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$vux.toast.text("未能获取到量表信息！", "top");
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.outsiderScaleList = e.rtnObj;
            } else {
              self.outsiderScaleList = [];
            }
            self.loginflag = false;
          }
        },
        "MMPTBiz.GetScaleListByTaskIdNoToken2",
        this.$route.query.taskOutsideId
      );
    },
    // 去完成前弹框方法
    Finish(row) {
      this.centerDialogVisible = true;
      let info = {
        taskId: row.task_id,
        register_id: row.register_id,
        idcard: this.$route.query.idcard,
        scale_id: row.scale_id,
        task_out_rel_id: this.$route.query.taskOutsideId,
        title: row.title,
        question_type: row.question_type,
        customrule: row.customrule,
      };
      this.instruction = row.instruction;
      window.sessionStorage.setItem("info", JSON.stringify(info));
    },
    // 去完成
    toFinish() {
      this.$router.push({
        name: "outsiderAnswer",
        query: {
          rel_id: this.$route.query.taskOutsideId,
        },
      });
    },
  },
  // 下一步
  next() {
    if (!this.outsiderInfo.task_id)
      return self.$message.error("未查询到测评信息！ ");
    this.$router.push({
      name: "outsiderAnswerList",
      query: {
        taskOutsideId: this.outsiderInfo.res_id,
      },
    });
  },
  blurChange() {
    if (this.form.outsiderId) {
      this.GetTaskOutsider();
    } else {
      return;
    }
  },
  // 获取校外人员测评任务
  GetTaskOutsider() {
    let self = this;
    LYCom.AsynCallBiz(
      function (e) {
        if (e.err) {
          self.$message.error("未查询到测评信息！ ");
        } else {
          if (e.rtnObj) {
            self.outsiderInfo = e.rtnObj;
            //   判断性别
            if (self.outsiderInfo.sex == 1) {
              self.outsiderInfo.sex = "男";
            } else if (self.outsiderInfo.sex == 2) {
              self.outsiderInfo.sex = "女";
            }
            //   出生日期
            if (self.outsiderInfo.birthday) {
              self.outsiderInfo.birthday = new Date(
                self.outsiderInfo.birthday
              ).format("yyyy-MM-dd");
            }
            self.isNext = false;
          } else {
            self.outsiderInfo = {
              idcard: "",
              name: "",
              age: "",
              birthday: "",
              sex: "",
            };
          }
        }
      },
      "TaskBiz.GetTaskOutsiderNoToken",
      self.form.outsiderId
    );
  },
};
</script>
 
<style scoped>
.header {
  height: 70px;
  box-shadow: 0px 5px 15px #b3c6fc;
  color: white;
  background-image: url(/static/images/header_bg.jpg);
  z-index: 99;
  position: relative;
}
.head_warp {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 15px;
}
.head_title {
  font-size: 24px;
}
.content .warp {
  padding: 20px 20px 20px 20px;
}
.back-head {
  padding-top: 60px;
  line-height: 100%;
}
.back-head h3 {
  font-size: 20px;
  font-weight: 400;
}
.back-head p {
  margin: 15px 0 60px;
  font-size: 16px;
  color: #333;
}
/deep/ .el-radio__label {
  font-size: 20px;
  color: #000;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #091d7c;
}

.next {
  width: 780px;
  text-align: center;
}
.next_btn {
  padding: 12px 50px;
}
.area_list {
  display: flex;
  width: 675px;
}
.class_warp {
  width: 675px;
  display: flex;
}
.radio_warp {
  margin: 20px 0;
}
.area_list .el-select,
.class_warp .el-select {
  flex: 1;
}

.el-form-item {
  margin-bottom: 30px;
}

.rest_title {
  font-size: 20px;
  padding: 10px;
  height: 40px;
  line-height: 40px;
  width: 780px;
  margin: 20px 0;
}
.footer_line {
  height: 10px;
  background: linear-gradient(left, #000147, #1cb4df);
}

.main-footer {
  height: 30px;
  text-align: center;
  margin-top: 10px;
}
.main-footer a {
  font-size: 13px;
  color: #999999;
  text-decoration: none;
}
.content {
  margin: 20px 20px 10px 20px;
}
.warp {
  background: white;
  border-radius: 5px;
  box-shadow: 0 0 32px #ccc;
}
.cursor {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/outsideranswer/OutsiderAnswerList.vue